/*
 * @Author: bobo 350910378@qq.com
 * @Date: 2022-04-07 15:43:33
 * @LastEditors: bobo 350910378@qq.com
 * @LastEditTime: 2024-11-16 15:11:06
 * @FilePath: \baishu_react_ui\src\components\BsyIconBtn\index.jsx
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
 */
import React from "react";
import BsyIconBtn from "../BsyIconBtn";
import "./index.css";
import BsyAlert from "../BsyAlert";
import { BsyUtils } from "../../utils/Utils";

export default class BsyButton extends BsyIconBtn {
  constructor(props) {
    super({
      baseCls: "BsyBtn",
      ...props,
    });
    this.state = {
      ...this.state,
    };
  }

  getStyle = (mode = "") => {
    const { css, background, theme = "" } = this.options;
    let newCss = { ...css };
    if (background) {
      switch (theme) {
        case "style1":
          if (background.mode === "color") {
            newCss.background = "transparent";
            newCss.color = background.color;
            newCss.borderColor = background.color;
          }

          break;
        case "none":
          if (background.mode === "color") {
            newCss.background = "transparent";
            newCss.borderColor = "transparent";
            newCss.color = background.color;
          }
          break;
        default:
          if (background.mode === "color") {
            newCss.background = background.color;
            newCss.color = "#fff";
            newCss.borderColor = background.color;
          }
      }
    }
    return newCss;
  };

  onClick = (e) => {
    const { click, enable, eventAlert, alertinfo } = this.options;
    let that = this;
    if (enable) {
      if (eventAlert) {
        BsyAlert({
          title: alertinfo.msg,
          type: alertinfo.icon,
          msg: "",
          text4Ok: React.language("ok"),
          OkType: alertinfo.icon === "error" ? "red" : "blue",
          text4Cancel: React.language("cancel"),
          ok: () => {
            click && click(e, null, that);
          },
        });
      } else {
        click && click(e, null, this);
      }
    }
  };

  onMouseEnter = (event) => {
    let css = this.getStyle("hover");
    const { currentTarget } = event;
    BsyUtils.forEach(css, (key, value) => {
      currentTarget.style[key] = value;
    });
  };

  onMouseLeave = (event) => {
    let css = this.getStyle();
    const { currentTarget } = event;
    BsyUtils.forEach(css, (key, value) => {
      currentTarget.style[key] = value;
    });
  };

  render() {
    const { cssName, iconName, text, accept, file, style, enable, theme } =
      this.options;
    let css = this.getStyle();
    return (
      <div
        className={`${cssName} ${style} ${theme}`}
        style={css}
        onClick={this.onClick}
        onMouseEnter={enable ? this.onMouseEnter : () => {}}
        onMouseLeave={enable ? this.onMouseLeave : () => {}}
        title={this.options.title}
      >
        <div className="btnCont">
          {iconName && <i className={iconName} />}
          {text && <span>{text}</span>}
        </div>
        {file && (
          <form
            className="upload-form "
            action=""
            encType="multipart/form-data"
            method="post"
          >
            <input
              type="file"
              onChange={this.onChange}
              name="file"
              id="file"
              className="upload-btn-input"
              accept={accept}
            />
          </form>
        )}
      </div>
    );
  }
}
